import {
  Box,
  CircularProgress,
  Grid,
  Modal,
  Paper,
  Tooltip,
  Typography,
} from "@mui/material";
import React, { useState, useEffect } from "react";
import deletebox from "../../Utils/Images/deletebox.png";
import editbox from "../../Utils/Images/editbox.png";
import CustomButton from "../../Components/Button/CustomButton";
import { Link } from "react-router-dom";
import { handleDeleteLinks } from "../../APIs/Function/HomePageLinks/DeletePageLinks";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import { GetHomePagelinks } from "../../APIs/Function/HomePageLinks/GetHomePagelinks";
import DeleteModal from "../Modal/DeleteModal";
import { Translate } from "@mui/icons-material";
import Loader from "../Loader/Loader";

const HomePageTable = ({ setPageLinksData, pageLinksData }) => {
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [modalID, setModalID] = useState("");

  const handleDelete = async () => {
    await handleDeleteLinks(modalID);
    setOpen(false);
    let res = await GetHomePagelinks();
    setPageLinksData(res.r);
    alert("Page Link Deleted Successfully");
  };

  const handleModal = (id) => {
    setModalID(id);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  useEffect(() => {}, [pageLinksData]);
  return (
    <>
      {loading ? (
        <Box sx={{ mt: "25%" }}>
       <Loader />
        </Box>
      ) : (
        <Box>
          {/* table heading */}
          <Box
            sx={{
              boxShadow: "none",
              outline: "none",
              mb: "10px",
              border: "none",
              mt: "30px",
              boxSizing: "border-box",
            }}
          >
            <Grid container>
              {/* first column */}
              <Grid item xs={0.5} md={0.5}>
                <Paper
                  sx={{
                    borderRadius: "0px",
                  border: "0.5px solid #DDDDDD",
                    boxShadow: "none",
                    height: "50px",
                    display: "flex",
                    alignItems: "center",
                    textAlign: "center",
                    justifyContent: "center",    bgcolor: "#E6E6E6",
                  }}
                >
                  <Typography
                    sx={{
                      fontFamily: "inter",
                      fontWeight: "400",
                      fontSize: "16px",
                      opacity: "85%",
                      color: "#252525",
                    }}
                  >
                    #
                  </Typography>
                </Paper>
              </Grid>
              {/* Second Column */}
              <Grid item xs={2} md={2}>
                <Paper
                  sx={{
                    borderRadius: "0px",
                  border: "0.5px solid #DDDDDD",
                    boxShadow: "none",
                    height: "50px",
                    display: "flex",
                    alignItems: "center",
                    textAlign: "center",
                    justifyContent: "center",    bgcolor: "#E6E6E6",
                  }}
                >
                  <Typography
                    sx={{
                      fontFamily: "inter",
                      fontWeight: "400",
                      fontSize: "16px",

                      opacity: "85%",
                      color: "#252525",
                    }}
                  >
                    Photo
                  </Typography>
                </Paper>
              </Grid>
              {/* Third Column */}
              <Grid item xs={2.5} md={2.5}>
                <Paper
                  sx={{
                    borderRadius: "0px",
                  border: "0.5px solid #DDDDDD",
                    boxShadow: "none",
                    height: "50px",
                    display: "flex",
                    alignItems: "center",
                    textAlign: "center",
                    justifyContent: "center",    bgcolor: "#E6E6E6",
                  }}
                >
                  <Typography
                    sx={{
                      fontFamily: "inter",
                      fontWeight: "400",
                      fontSize: "16px",

                      opacity: "85%",
                      color: "#252525",
                    }}
                  >
                    Name
                  </Typography>
                </Paper>
              </Grid>
              {/* Fourth Column */}
              <Grid item xs={2.5} md={2.5}>
                <Paper
                  sx={{
                    borderRadius: "0px",
                  border: "0.5px solid #DDDDDD",
                    boxShadow: "none",
                    height: "50px",
                    display: "flex",
                    alignItems: "center",
                    textAlign: "center",
                    justifyContent: "center",    bgcolor: "#E6E6E6",
                  }}
                >
                  <Typography
                    sx={{
                      fontFamily: "inter",
                      fontWeight: "400",
                      fontSize: "16px",
                      opacity: "85%",
                      color: "#252525",
                    }}
                  >
                    Description
                  </Typography>
                </Paper>
              </Grid>
              {/* fifth Column */}
              <Grid item xs={2.5} md={2.5}>
                <Paper
                  sx={{
                    borderRadius: "0px",
                  border: "0.5px solid #DDDDDD",
                    boxShadow: "none",
                    height: "50px",
                    display: "flex",
                    alignItems: "center",
                    textAlign: "center",
                    justifyContent: "center",    bgcolor: "#E6E6E6",
                  }}
                >
                  <Typography
                    sx={{
                      fontFamily: "inter",
                      fontWeight: "400",
                      fontSize: "16px",

                      opacity: "85%",
                      color: "#252525",
                    }}
                  >
                    Link
                  </Typography>
                </Paper>
              </Grid>
              {/* Sixth Column */}
              <Grid item xs={2} md={2}>
                <Paper
                  sx={{
                    borderRadius: "0px",
                  border: "0.5px solid #DDDDDD",
                    boxShadow: "none",
                    height: "50px",
                    display: "flex",
                    alignItems: "center",
                    textAlign: "center",
                    justifyContent: "center",    bgcolor: "#E6E6E6",
                  }}
                >
                  <Typography
                    sx={{
                      fontFamily: "inter",
                      fontWeight: "400",
                      fontSize: "16px",

                      opacity: "85%",
                      color: "#252525",
                    }}
                  >
                    Action
                  </Typography>
                </Paper>
              </Grid>
            </Grid>
          </Box>
          {/* table data */}
          <Box
            sx={{ border: "0.5px solid #DDDDDD",
              overflow: "auto",
              minHeight: "100px",
              maxHeight: "415px",
              "&:hover": {
                "::-webkit-scrollbar": {
                  width: "5px",
                  borderRadius: "10px",
                },
                "::-webkit-scrollbar-thumb": {
                  bgcolor: "gray",
                  borderRadius: "10px",
                },
              },
            }}
          >
            <Grid container>
              {/* first column */}
              <Grid item xs={0.5} md={0.5}>
                {pageLinksData?.map((e, i) => (
                  <Paper
                    key={i}
                    sx={{
                      borderRadius: "0px",
                    border: "0.5px solid #DDDDDD",
                      boxShadow: "none",
                      height: "50px",
                      display: "flex",
                      alignItems: "center",
                      textAlign: "center",
                      justifyContent: "center",
                    }}
                  >
                    <Typography
                      sx={{
                        fontFamily: "inter",
                        fontWeight: "400",
                        fontSize: "16px",
                      }}
                    >
                      {i + 1}
                    </Typography>
                  </Paper>
                ))}
              </Grid>

              {/* Second Column */}

              <Grid item xs={2} md={2}>
                {pageLinksData?.map((e, i) => (
                  <Paper
                    key={i}
                    sx={{
                      borderRadius: "0px",
                    border: "0.5px solid #DDDDDD",
                      boxShadow: "none",
                      height: "50px",
                      display: "flex",
                      alignItems: "center",
                      textAlign: "center",
                      justifyContent: "center",
                    }}
                  >
                    <Box
                      sx={{
                        width: "45px",
                        height: "45px",
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      <img
                        style={{ width: "100%", height: "100%" }}
                        src={`https://api-qhealth.equitysofttechnologies.com/upload/images/${e.photo}`}
                        alt=""
                      />
                    </Box>
                  </Paper>
                ))}
              </Grid>

              {/* Third Column */}

              <Grid item xs={2.5} md={2.5}>
                {pageLinksData?.map((e, i) => (
                  <Paper
                    key={i}
                    sx={{
                      borderRadius: "0px",
                    border: "0.5px solid #DDDDDD",
                      boxShadow: "none",
                      height: "50px",
                      display: "flex",
                      alignItems: "center",
                      textAlign: "center",
                      justifyContent: "center",
                    }}
                  >
                    <Typography
                      sx={{
                        fontFamily: "inter",
                        fontWeight: "400",
                        fontSize: "16px",

                        textOverflow: "ellipsis",
                        overflow: "hidden",
                        maxWidth: "100%",
                        "&:hover": {
                          overflow: "visible",
                        },
                      }}
                    >
                      {e.name}
                    </Typography>
                  </Paper>
                ))}
              </Grid>

              {/* Fourth Column */}

              <Grid item xs={2.5} md={2.5}>
                {pageLinksData?.map((e, i) => (
                 
                    <Paper
                      sx={{
                        borderRadius: "0px",
                      border: "0.5px solid #DDDDDD",
                        boxShadow: "none",
                        height: "50px",
                        alignItems: "center",
                        textAlign: "center",
                        justifyContent: "center",
                        display: "flex",
                      }}
                    > <Tooltip
                    key={i}
                    title={e.description}
                    arrow
                  >
                      <Typography
                        noWrap
                        sx={{
                          cursor: "pointer",
                          m: "auto",
                          fontFamily: "inter",
                          fontWeight: "400",
                          fontSize: "16px",
                          width: "200px",
                          textOverflow: "ellipsis",
                        }}
                      >
                        {e.description}
                      </Typography>
                  </Tooltip>
                    </Paper>
                ))}
              </Grid>

              {/* fifth Column */}
              <Grid item xs={2.5} md={2.5}>
                {pageLinksData?.map((e, i) => (
                  <Paper
                    key={i}
                    sx={{
                      borderRadius: "0px",
                    border: "0.5px solid #DDDDDD",
                      boxShadow: "none",
                      height: "50px",
                      display: "flex",
                      alignItems: "center",
                      textAlign: "center",
                      justifyContent: "center",
                    }}
                  >
                    <Typography
                      noWrap
                      sx={{
                        fontFamily: "inter",
                        fontWeight: "400",
                        fontSize: "16px",
                        textOverflow: "ellipsis",
                        overflow: "hidden",
                        maxWidth: "90%",
                        "&:hover": {
                          overflow: "auto",
                        },
                      }}
                    >
                      {e.link}
                    </Typography>
                  </Paper>
                ))}
              </Grid>
              {/* Sixth Column */}
              <Grid item xs={2} md={2}>
                {pageLinksData?.map((e, i) => (
                  <Paper
                    key={i}
                    sx={{
                      borderRadius: "0px",
                    border: "0.5px solid #DDDDDD",
                      boxShadow: "none",
                      height: "50px",
                      display: "flex",
                      alignItems: "center",
                      textAlign: "center",
                      justifyContent: "center",
                    }}
                  >
                    <Box
                      sx={{
                        display: "flex",
                        width: "100%",
                        gap: "15px",
                        justifyContent: "center",
                      }}
                    >
                      <Box
                        sx={{
                          cursor: "pointer",
                          width: { xs: "30%", md: "40px" },
                          height: { xs: "30%", md: "40px" },
                        }}
                      >
                        <img
                          onClick={() => {
                            handleModal(e.id);
                          }}
                          width={"100%"}
                          height={"100%"}
                          src={deletebox}
                          alt=""
                        />
                      </Box>
                      <Box
                        sx={{
                          cursor: "pointer",
                          width: { xs: "30%", md: "40px" },
                          height: { xs: "30%", md: "40px" },
                        }}
                      >
                        <Link to={`/editpagelinks/${e.id}`}>
                          <img
                            width={"100%"}
                            height={"100%"}
                            src={editbox}
                            alt="logo"
                          />
                        </Link>
                      </Box>
                      <DeleteModal
                        open={open}
                        handleDelete={handleDelete}
                        modalID={modalID}
                        onClose={handleClose}
                      />
                    </Box>
                  </Paper>
                ))}
              </Grid>
            </Grid>
          </Box>
          <Box
            sx={{
              display: "flex",
              mt: "25px",
              justifyContent: "end",
              width: "100%",
            }}
          >
            <Link to={"/addpagelinks"}>
              <CustomButton
                sx={{
                  width: "100%",
                  bgcolor: "#31AEF4",
                  "&:hover": {
                    bgcolor: "#31AEF4",
                  },
                }}
              >
                ADD +
              </CustomButton>
            </Link>
          </Box>
        </Box>
      )}
    </>
  );
};

export default HomePageTable;
